import { useMemo } from 'react';
import { DocumentReference } from 'firebase/firestore';
import { useDocumentData as _useDocumentData } from 'react-firebase-hooks/firestore';

export const useDocumentData = <T>(ref?: DocumentReference<T> | null) => {
  const [data, loading, error, snapshot] = _useDocumentData(ref, { snapshotOptions: { serverTimestamps: 'estimate' } });
  return useMemo(() => ({ data, loading, error, snapshot }), [data, loading, error, snapshot]);
};
